import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { convertTimeValueToTimeString } from "@/modules/duration/timeConverter"
import { cn } from "@/modules/lib/utils"
import { ChronoRecapBloc } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/components/chronoRecapBloc"
import {
  convertChronoFormikToChronoDraft,
  type ExerciseFormikType,
  type ExerciseInputKey,
} from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import type { SimpleFormik } from "@/typings/formik"
import { AmrapIcon } from "@images/svgIcons/amrapIcon"
import { ChronoIcon } from "@images/svgIcons/chronoIcon"
import { TrashIcon } from "@images/svgIcons/trashIcon"
import { displayTotalTime } from "@modules/chrono/chronoUtils"
import { word } from "@modules/core/utils/i18n"
import { useMemo } from "react"

export function ChronoAmrapRecap({
  formik,
  className,
  ...props
}: { formik: SimpleFormik<ExerciseFormikType, ExerciseInputKey> } & React.ComponentProps<"div">) {
  const displayChronoTime = useMemo(() => {
    const chronoDraft = convertChronoFormikToChronoDraft(formik.values)

    if (chronoDraft === undefined) return word("chrono.title.no_chrono")

    return displayTotalTime(chronoDraft)
  }, [formik.values])

  const onDeleteChronoClick = () => {
    formik.setFieldValue("chronoAmrap", undefined)
    formik.setFieldValue("chrono", undefined)
    formik.setFieldValue("chronoType", undefined)
  }

  return (
    <div className={cn("flex flex-col", className)} {...props}>
      <div className="mb-2 flex flex-row items-start justify-between">
        <AmrapIcon color="currentColor" className="text-textOnColor-body" />

        <div className="flex flex-col items-center">
          <Text fontStyle="LS">{word("chrono.title.amrap")}</Text>

          <div className="flex items-center">
            <ChronoIcon color="currentColor" className="text-textDefault-body" />
            <Text className="ml-2" fontStyle="TL">
              {displayChronoTime}
            </Text>
          </div>
        </div>

        <Button variant="ghost" size="iconMd" onClick={onDeleteChronoClick}>
          <TrashIcon color="currentColor" className="text-textDefault-body" width={22} height={22} />
        </Button>
      </div>

      {formik.values.chronoAmrap?.trainingTime && (
        <>
          {formik.values.chronoAmrap.trainingTime.map((trainingTime, i) => (
            <div key={i} className="mb-1 flex items-center justify-between gap-2">
              <div className="mr-1">
                <Text fontStyle="LM">{word("chrono.title.amrap") + " " + (i + 1)}</Text>
              </div>

              <ChronoRecapBloc playIcon value={convertTimeValueToTimeString(trainingTime, "00m 00s")} />

              {i !== 0 && formik.values.chronoAmrap?.restTime[i] ? (
                <ChronoRecapBloc
                  circleBreakIcon
                  value={convertTimeValueToTimeString(formik.values.chronoAmrap.restTime[i], "00m 00s")}
                />
              ) : null}
            </div>
          ))}
        </>
      )}
    </div>
  )
}
